//#region Imports and Types
import type {
  Logger as DatadogLogger,
  LogsInitConfiguration,
} from '@datadog/browser-logs';
import { datadogLogs } from '@datadog/browser-logs';
import { createLogMethods } from './log-methods.util';
import type { LoggerConfig } from './logger.util';

export type LoggerInitConfiguration = LogsInitConfiguration & LoggerConfig;
//#endregion

//#region State
let isDatadogInitialized = false;
//#endregion

//#region Datadog Initialization
const initializeDatadog = (
  config: LoggerInitConfiguration
): Nullable<DatadogLogger> => {
  if (!config.isMonitoringEnabled) return null;
  if (isDatadogInitialized) return datadogLogs.logger;
  datadogLogs.init(config);
  isDatadogInitialized = true;
  return datadogLogs.logger;
};
//#endregion

//#region Main Logger Factory
export const createLogger = (config: LoggerInitConfiguration) => {
  const loggerInstance: Nullable<DatadogLogger> = initializeDatadog(config);
  return createLogMethods(loggerInstance, config);
};
//#endregion
